// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FastforwardIconSignature {
  Element: SVGSVGElement;
}

export const FastforwardIcon: TOC<FastforwardIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.625 3L20.625 11C20.862 11.189 21 11.476 21 11.78C21 12.084 20.862 12.372 20.624 12.562L10.624 20.562L9.375 19L18.399 11.78L9.375 4.561L10.625 3ZM14.371 11.78C14.371 11.159 14.09 10.584 13.599 10.202L7.228 5.246C6.639 4.788 5.789 4.702 5.121 5.029C4.44 5.362 4 6.067 4 6.825V16.735C4 17.493 4.44 18.198 5.121 18.532C5.813 18.87 6.627 18.782 7.228 18.315L13.6 13.358C14.09 12.976 14.371 12.401 14.371 11.78ZM6 16.735V6.825L12.372 11.78L6 16.735Z"/>
</svg>
</template>;